// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getServiceById } from 'app/constants/enums/Service/main';

/* eslint-disable max-len */
export const BLOG = getServiceById('Blog');
export const DAILY_NEWS = getServiceById('DailyNews');
export const LIVE_LESSONS = getServiceById('LiveLessons');
export const LIVE_LESSONS_B2_B = getServiceById('LiveLessonsB2B');
export const LIVE_LESSONS_B2_S = getServiceById('LiveLessonsB2S');
export const QAND_A = getServiceById('QandA');
export const STUDY_ABROAD = getServiceById('StudyAbroad');
export const TUTOR = getServiceById('Tutor');
export const WORDS = getServiceById('Words');
export const I_KNOW = getServiceById('iKnow');
/* eslint-enable max-len */
